import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { mediaQuery } from "src/common";
import IconModalClose from "../icons/closeModal.icon";

const BaseModalComponent = styled.div({
  padding: 24,
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 100,
  backgroundColor: 'rgba(50, 50, 50, 0.55)',
  transition: 'all 0.5s ease-in-out',
})

const BaseModalContent = styled.div({
  boxSizing: 'border-box',
  backgroundColor: '#FFF',
  borderRadius: 16,
  maxHeight: '92%',
  width: 'calc(100% - 40px)',
  maxWidth: 480,
  position: 'fixed',
  top: '50%',
  left: '50%',
  right: 'auto',
  bottom: 'auto',
  transform: 'translate(-50%, -50%)',
  zIndex: 2,
  padding: 24,
  overflow: 'auto',
  boxShadow: '0 4px 40px rgba(0, 0, 0, 0.06)',
  transition: 'all 0.5s ease-in-out',
  [mediaQuery('tablet')]: {
    padding: 48,
  }
})

const BaseModalClose = styled(IconModalClose)({
  position: 'absolute',
  top: 24,
  right: 24,
  [mediaQuery('tablet')]: {
    top: 30,
    right: 30,
  }
})

export type BaseModalProps = {
  open: boolean;
  onClose: () => void;
  children?: React.ReactNode;
};

const BaseModal: React.FC<BaseModalProps> = ({
  open,
  onClose,
  children,
}) => {
  useEffect(() => {
    if (open) {
      const currentOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = currentOverflow;
      };
    }

    return undefined;
  }, [open]);

  if (!open) {
    return null;
  }

  return (
    <BaseModalComponent>
      <BaseModalContent>
        <BaseModalClose onClick={onClose} />
        {children}
      </BaseModalContent>
    </BaseModalComponent>
  );
};

export default BaseModal;